module.exports = __webpack_public_path__ + "static/media/object_immotal4.d4d57547.png";